import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import Icon from 'carbon-react/lib/components/icon';
import Box from 'carbon-react/lib/components/box';
import Button from 'carbon-react/lib/components/button';

import { AccountCategory } from '@futrli-sdk/predict';

import { COADisplayAccount, SWITCH_RULE_CATEGORIES } from '../../types';
import * as styles from './group-row-actions.scss';

interface Props {
  isBalanceSheet: boolean;
  row: COADisplayAccount;
  accountCategoryNames: Record<AccountCategory, string>;
  onSwitchRuleClick: (coaRow: COADisplayAccount) => void;
  isUpdatingStructure: boolean;
}

export const DaysToPaySwitchRule = ({
  isBalanceSheet,
  row,
  accountCategoryNames,
  onSwitchRuleClick,
  isUpdatingStructure
}: Props) => {
  if (isBalanceSheet) {
    // Only asset/liability categories can have switch rules
    const showSwitchRule = SWITCH_RULE_CATEGORIES.indexOf(row.category as AccountCategory) !== -1;

    if (!showSwitchRule && !row.switch_rule_category) {
      return <>{'-'}</>;
    }

    if (showSwitchRule && !row.switch_rule_category) {
      return (
        <div
          onClick={() => onSwitchRuleClick(row)}
          className={`${styles.darkFont} ${isUpdatingStructure ? styles.disabled : ''}`}
        >
          <Button buttonType="tertiary" iconType="add" iconPosition="before" onClick={() => onSwitchRuleClick(row)}>
            <span style={{ marginLeft: '4px' }}>
              <FormattedMessage id="predict.add" defaultMessage="Add" />
            </span>
          </Button>
        </div>
      );
    }

    return (
      <Box display="flex" alignItems="center" gap="8px">
        <Icon type="arrows_left_right" color="#668494" />
        <FormattedMessage
          id="predict.move_to_if_negative"
          defaultMessage="Move to {switchCategory} if negative"
          values={{ switchCategory: accountCategoryNames[row.switch_rule_category as AccountCategory] }}
        />
      </Box>
    );
  }

  return <>{row.days_to_pay || '-'}</>;
};
